import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Login } from "../containers/Public/Login";
import { SignUp } from "../containers/Public/Signup";
import { ForgotPassword } from "../containers/Public/ForgotPassword";
import { VerifiedPage } from "../containers/Public/InformationPage";

export function PublicRoutes() {
  return (
    <Routes>
      <Route path="/*" element={<Navigate to="/login" />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<SignUp />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/verified-page" element={<VerifiedPage />} />
    </Routes>
  );
}
